import React from "react";
import { Box, Typography } from "@mui/material";
import { SCORE_OPTIONS } from "../constants";

function scoreColor(n) {
  if (n >= 9) return { bg: "#ecfdf5", border: "#6ee7b7", text: "#059669" };
  if (n >= 7) return { bg: "#f0fdf4", border: "#86efac", text: "#16a34a" };
  if (n >= 5) return { bg: "#fffbeb", border: "#fcd34d", text: "#d97706" };
  if (n >= 1) return { bg: "#fff7ed", border: "#fdba74", text: "#ea580c" };
  return { bg: "#f9fafb", border: "#e5e7eb", text: "#9ca3af" };
}

export default function ScorePicker({ label, value = 0, onChange, compact = false, disabled = false, accent = "#1975d1" }) {
  return (
    <Box sx={{ opacity: disabled ? 0.55 : 1, pointerEvents: disabled ? "none" : "auto" }}>
      {label && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 0.75,
            fontWeight: 600,
            color: "#6b7280",
            letterSpacing: "0.02em",
            fontSize: compact ? "0.7rem" : "0.75rem",
          }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: compact ? "3px" : "4px",
          maxWidth: compact ? "none" : 360,
        }}
      >
        {SCORE_OPTIONS.map((n) => {
          const selected = value === n;
          const c = scoreColor(n);
          return (
            <Box
              key={n}
              component="button"
              type="button"
              onClick={() => !disabled && onChange(n)}
              aria-label={`${label || "Puntaje"} ${n}`}
              aria-pressed={selected}
              disabled={disabled}
              sx={{
                width: compact ? 24 : { xs: 28, sm: 32 },
                height: compact ? 24 : { xs: 28, sm: 32 },
                borderRadius: "8px",
                border: "1.5px solid",
                borderColor: selected ? accent : c.border,
                bgcolor: selected ? accent : c.bg,
                color: selected ? "#fff" : c.text,
                fontSize: compact ? "0.7rem" : { xs: "0.75rem", sm: "0.8rem" },
                fontWeight: selected ? 700 : 500,
                cursor: disabled ? "default" : "pointer",
                p: 0,
                lineHeight: 1,
                transition: "all 0.15s ease",
                fontFamily: "inherit",
                "&:hover": disabled
                  ? {}
                  : {
                      borderColor: selected ? accent : accent,
                      transform: "translateY(-1px)",
                      boxShadow: `0 2px 6px ${accent}26`,
                    },
                "&:focus-visible": {
                  outline: `2px solid ${accent}`,
                  outlineOffset: 2,
                },
              }}
            >
              {n}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
